import React from "react";
import { LogInIcon, XIcon } from "lucide-react";
import { STORE_CHECK_IN_RADIUS_METERS } from "../utils/storeCheckInGeofence";

type Props = {
  open: boolean;
  onClose: () => void;
  onOpenCheckIn: () => void;
};

const CheckInRequiredModal: React.FC<Props> = ({
  open,
  onClose,
  onOpenCheckIn,
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="w-full max-w-sm rounded-xl bg-white p-6 shadow-lg"
        role="dialog"
        aria-modal="true"
        aria-labelledby="check-in-required-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-start justify-between gap-2">
          <h3
            id="check-in-required-title"
            className="text-lg font-semibold text-gray-900"
          >
            Check in required
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1 text-gray-500 hover:bg-gray-100"
            aria-label="Close"
          >
            <XIcon size={18} />
          </button>
        </div>
        <p className="mb-4 text-sm text-gray-600">
          You can view basket orders anytime, but you must check in at your store
          (within {STORE_CHECK_IN_RADIUS_METERS} m) before confirming orders and
          moving them to
          Today&apos;s deliveries.
        </p>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={onOpenCheckIn}
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 py-2.5 text-sm font-semibold text-white hover:bg-emerald-700"
          >
            <LogInIcon size={18} aria-hidden />
            Check in now
          </button>
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-lg border border-gray-200 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Stay on basket
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckInRequiredModal;
